<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>404 - Página no encontrada</title>
    <link href="https://cdnjs.cloudflare.com/ajax/libs/tailwindcss/2.2.19/tailwind.min.css" rel="stylesheet">
    <style>
        @keyframes float {
            0% { transform: translatey(0px); }
            50% { transform: translatey(-20px); }
            100% { transform: translatey(0px); }
        }
        .float {
            animation: float 3s ease-in-out infinite;
        }
    </style>
</head>
<body class="bg-gradient-to-r from-blue-100 to-purple-200 flex items-center justify-center min-h-screen">

    <div class="text-center p-8 rounded-lg shadow-lg bg-white max-w-lg">
        <h1 class="text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600 float">404</h1>
        <p class="mt-4 text-2xl text-gray-700">La página que intentas acceder no existe.</p>
        <p class="mt-2 text-gray-500">Pero no te preocupes, puedes volver a la página principal.</p>
        <button (click)="returnDashboard()"  type="button" class="cursor-pointer mt-6 inline-block px-6 py-3 bg-purple-600 text-white text-lg font-semibold rounded-full shadow-md hover:bg-purple-700 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110">
            Volver al inicio
        </button>
    </div>

</body>
</html>
